import unfetch from 'isomorphic-unfetch'
import {
  RequestInfo,
  DedupeOpts,
  RequestInit,
  RequestInitWithDedupe,
  Response,
} from '../types'
import { dedupeFetch } from './dedupeFetch'
import { timeoutFetch } from './timeoutFetch'

const getDedupeOpts = (
  input: RequestInfo,
  init?: RequestInitWithDedupe,
): DedupeOpts | null => {
  if (!init?.dedupe) {
    return null
  }

  if (typeof input !== 'string') {
    return null
  }

  if (init.dedupe === true) {
    return {}
  }

  return init.dedupe
}

export const augmentedFetch = async (
  info: RequestInfo,
  init?: RequestInit,
): Promise<Response> => {
  let baseFetch = init?.timeout ? timeoutFetch : unfetch

  // use the real fetch when mocking
  if (process.env.NEXT_PUBLIC_API_MOCKING === 'true') {
    baseFetch = fetch
  }

  const dedupeOpts = getDedupeOpts(info, init)

  if (dedupeOpts) {
    return dedupeFetch(baseFetch, info, init, dedupeOpts)
  }

  return baseFetch(info, init)
}
